import { ProductActivationStatusResponse } from '@atlassiansox/asc-stargate';

export type CloudStatus = {
	readonly createCloudStatus: CreateCloudStatus;
	readonly readyPollCloudStatus: boolean;
	readonly isProduction: boolean;
	readonly onDemandUrl: string;
	readonly cloudId: string;
	readonly platform?: string;
	readonly requestId: string;
	readonly triggerOnSuccess: boolean;
	readonly onSuccessDuration: number;
	readonly perceivedProvisioningStartTime?: number;
	readonly productActivationStatusResponses: ProductActivationStatusResponse[];
	readonly createRedirectUrl: (isOnlyUrl: boolean) => string;
	readonly onSuccess: (startTime: number) => void;
	readonly startPerceivedProvisioningTimer: () => void;
	readonly pollCloudStatus: (startTime?: number, run?: number) => void;
	readonly setFireOnRedirectAnalytics: (fireOnRedirectAnalytics: boolean) => void;
	readonly setCreateCloudStatus: (createCloudStatus: CreateCloudStatus) => void;
	readonly getCloudStatus: () => void;
};
export type CloudStatusProviderProps = {
	readonly timeout?: number;
	readonly isProduction?: boolean;
	readonly onDemandUrl: string;
	readonly cloudId: string;
	readonly platform?: string;
	readonly requestId: string;
	readonly graphQlTimeout?: number;
	readonly isDirectBuy?: boolean;
};
export type CreateCloudStatus =
	| 'pending'
	| 'success'
	| 'timeout'
	| 'timeout-recoverable'
	| 'error'
	| 'error-unrecoverable';

export const DEFAULT_TIMEOUT = 10 * 60000;
export const DEFAULT_CREATE_CLOUD_STATUS: CreateCloudStatus = 'pending';
export const GRAPHQL_FALLBACK_TIMEOUT = 45000; // GraphQL timeout to fallback to control after 45 seconds
export const initCloudStatusContext: CloudStatus = {
	createCloudStatus: DEFAULT_CREATE_CLOUD_STATUS,
	readyPollCloudStatus: false,
	isProduction: false,
	onDemandUrl: '',
	cloudId: '',
	platform: 'ccp',
	requestId: '',
	triggerOnSuccess: false,
	onSuccessDuration: 0,
	perceivedProvisioningStartTime: Date.now(),
	productActivationStatusResponses: [],
	createRedirectUrl: () => '',
	onSuccess: () => undefined,
	startPerceivedProvisioningTimer: () => undefined,
	pollCloudStatus: () => undefined,
	setFireOnRedirectAnalytics: () => undefined,
	setCreateCloudStatus: () => undefined,
	getCloudStatus: () => undefined,
};
